import React, { useState } from "react";
import styled from "styled-components";
import { Popover, ConfigProvider } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import SuspendAccountModal from "./suspendAccount";
import { ReactComponent as Delete } from "images/vendor/Iconsdelete.svg";
import { VendorData } from "lib/hooks";
import { Link } from "react-router-dom";
import { routeNames } from "lib/routes";

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 800px;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
`;

const BusinessName = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  width: 25%;
`;

const Category = styled.div`
  width: 15%;
  padding-left: 16px;
`;

const EmailAddress = styled.div`
  width: 20%;
`;

const PhoneNumber = styled.div`
  width: 15%;
  padding-left: 16px;
`;

const DateTime = styled.div`
  width: 20%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #2f2f2f;
`;

const IndexText = styled(Text)`
  width: 24px;
`;

const SuspendAccount = styled.div``;

interface VendorCardProps {
  vendor: VendorData;
  number: number;
}

const MenuOption = styled.div`
  padding: 0.5rem;
  background-color: #f9fbff;
  border-radius: 8px;
  width: 8rem;
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`;

const OptionText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const VendorCard: React.FC<VendorCardProps> = ({ vendor, number }) => {
  const businessName = vendor.businessName || "N/A";
  const category = vendor.businessCategoryName || "N/A";
  const email = vendor.user?.email || vendor.vendorEmail || "N/A";
  const phone = vendor.user?.phone || vendor.phone || "N/A";
  const dateCreated = new Date(vendor.createdAt).toLocaleDateString();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteModalOpen = () => {
    setDeleteModalOpen(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
  };

  const content = (
    <MenuOption>
      <Top onClick={handleDeleteModalOpen}>
        <Delete />
        <OptionText>Suspend account</OptionText>
      </Top>
    </MenuOption>
  );

  return (
    <CardContainer>
      <StyledLink to={`${routeNames.adminVendorProfile}/${vendor.id}`}>
        <BusinessName>
          <IndexText>{number}</IndexText>
          <Text>{businessName}</Text>
        </BusinessName>
        <Category>
          <Text>{category}</Text>
        </Category>
        <EmailAddress>
          <Text>{email}</Text>
        </EmailAddress>
        <PhoneNumber>
          <Text>{phone}</Text>
        </PhoneNumber>
        <DateTime>
          <Text>{dateCreated}</Text>
        </DateTime>
      </StyledLink>
      <SuspendAccountModal open={deleteModalOpen} onCancel={handleDeleteModalClose} vendor={vendor.id} />
      <SuspendAccount>
        <ConfigProvider>
          <Popover placement="bottom" content={content} trigger="click">
            <EllipsisOutlined />
          </Popover>
        </ConfigProvider>
      </SuspendAccount>
    </CardContainer>
  );
};

export default VendorCard;
